import { AxiosRequestConfig, AxiosResponse } from "axios";

export interface ExtendedAxiosRequestConfig<T = any> extends AxiosRequestConfig<T> {
  isRefreshTokenRequest?: boolean;
  isEncrypted?: boolean;
  originalData?: T;
  delay?: number;
  retry?: number;
  retryDelay?: number;
  retryCondition?: (response?: AxiosResponse) => boolean;
}

export interface ApiResponseData<T = null> {
  code: number;
  error: unknown;
  payload: T;
}

export type ApiResponse<T = null> = AxiosResponse<ApiResponseData<T>>;
